import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/auth/SignIn.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/svgs/breezeup-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/svgs/line-mobile.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/svgs/Line.svg");
